import { AppDispatch, RootState } from '../index';
import { FetchState } from '../fetchState';
import { baseSlice, BaseType, getItem } from '../baseHelper';
import { TrainingDto } from '@api/models/training/TrainingDto';
import { EntityState } from '@api/models/enums/EntityState';
import { trainingService } from '@api/services/services';

type State = BaseType<TrainingDto>;

const initialState: State = {
  state: FetchState.None,
  data: {
    id: '',
    name: '',
    nameEn: '',
    state: EntityState.Active,
    workplaces: [],
    note: '',
    duration: 0,
  },
};

export const trainingSlice = baseSlice({
  name: 'training',
  initialState,
});

export const selectTrainingState = (state: RootState) => state.training.state;
export const selectTraining = (state: RootState) => state.training.data;
export const trainingActions = trainingSlice.actions;

export const getTraining = (trainingId: string) => (dispatch: AppDispatch) => {
  const handleGetData = () => {
    return trainingService.getById(trainingId);
  };

  getItem({
    dispatch,
    actions: trainingActions,
    getData: handleGetData,
  });
};
